export interface BookmakerData {
  brandColour: string;
  logoLarge: string;
  logoSmall?: string;
  textColour?: string | null;
}

const OC_LOGO_SRC = '/assets/img/oc-banner-logo.svg';

export const emptyBookmakerBranding: BookmakerData = {
  brandColour: '',
  logoLarge: '',
  logoSmall: '',
  textColour: '',
};

// Branding used when odds are shown as non-clickable OddsChecker odds (unsupported regions).
export const getOcBookmakerBranding = (resourcesUrl: string): BookmakerData => ({
  brandColour: 'var(--oc-primary-blue)',
  logoLarge: `${resourcesUrl}${OC_LOGO_SRC}`,
  logoSmall: `${resourcesUrl}${OC_LOGO_SRC}`,
  textColour: '#000000',
});
